module.exports = __webpack_public_path__ + "9ba0a33fb7f4f9a6bae892c3f33759d2.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/retribution.png
// module id = 525
// module chunks = 0